import React from 'react';

function ResultDisplay({ result }) {
  return (
    <div className="result-display">
      <h2>Result:</h2>
      <pre>{result}</pre>
    </div>
  );
}

export default ResultDisplay;